// GENERIC MODULE JS

// ACCORDION
let accordionBlocks = document.querySelectorAll(
    ".accordion__container .accordion__row"
);
accordionBlocks.forEach((row) => {
    row.querySelector(".row__header").addEventListener("click", () => {
        row.classList.toggle("expanded");
        let body = row.querySelector(".row__body");
        if (body.style.maxHeight) {
            body.style.maxHeight = null;
        } else {
            body.style.maxHeight = body.scrollHeight + "px";
        }
    });
});

// STAT CARDS
let statCardBlocks = document.querySelectorAll(
    ".component__stat-cards .swiper"
);
statCardBlocks.forEach((block) => {
    const swiperWrapper = block.querySelector(".swiper-wrapper");
    const swiperSlides = block.querySelectorAll(".swiper-slide");

    function updateSwiperStyles() {
        if (window.innerWidth < 768) {
            let swiperSlideHeight = swiperSlides[0].offsetHeight;
            swiperWrapper.style.display = "grid";
            swiperWrapper.style.gridTemplateRows = `repeat(${swiperSlides.length}, ${swiperSlideHeight}px)`;
        } else {
            swiperWrapper.style.display = "";
            swiperWrapper.style.gridTemplateRows = "";
        }
    }

    window.addEventListener("resize", updateSwiperStyles);
    updateSwiperStyles();
});

// INTERNAL LINKS
let internalLinksBlocks = document.querySelectorAll(
    ".component__internal-links .swiper"
);
internalLinksBlocks.forEach((block) => {
    const swiperWrapper = block.querySelector(".swiper-wrapper");
    const swiperSlides = block.querySelectorAll(".swiper-slide");

    function updateSwiperStyles() {
        if (window.innerWidth < 768) {
            let swiperSlideHeight = swiperSlides[0].offsetHeight;
            swiperWrapper.style.display = "grid";
            swiperWrapper.style.gridTemplateRows = `repeat(${swiperSlides.length}, ${swiperSlideHeight}px)`;
        } else {
            swiperWrapper.style.display = "";
            swiperWrapper.style.gridTemplateRows = "";
        }
    }

    window.addEventListener("resize", updateSwiperStyles);
    updateSwiperStyles();
});
